import { render, staticRenderFns } from "./WeatherWidgetItem.vue?vue&type=template&id=f8ddd4c0&"
import script from "./WeatherWidgetItem.vue?vue&type=script&lang=js&"
export * from "./WeatherWidgetItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports